export default __webpack_public_path__ + "static/media/cv pic.75617e05.jpg";